module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.showData.title,
      "visible": _vm.AddDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.AddDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "margin": "20px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "150px"
    }
  }, [_c('div', {
    staticClass: "v-com-form"
  }, [(_vm.showData.isReadOnly) ? _c('div', {
    staticClass: "v-com-matter"
  }) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代理商:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agent))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showData.isShowBtn),
      expression: "showData.isShowBtn"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.chooseAgent
    }
  }, [_vm._v("选择代理商")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "园所:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.school))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showData.isShowBtn || _vm.isSchoolKaike),
      expression: "showData.isShowBtn||isSchoolKaike"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.chooseSchool
    }
  }, [_vm._v("选择幼儿园")]), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.school !== '' && this.form.PackageId == 10082),
      expression: "school!==''&&this.form.PackageId==10082"
    }],
    staticStyle: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Hi幼教资源包未提数:" + _vm._s(_vm.debtPackage.HiDebtInfo) + ";")]), _vm._v(" "), _c('span', [_vm._v("智趣坞资源包未提数:" + _vm._s(_vm.debtPackage.BookHiData) + ";")]), _vm._v(" "), _c('span', [_vm._v("免邮费次数:" + _vm._s(_vm.debtPackage.FreePostData) + ";")])])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.PackageName !== ''),
      expression: "PackageName!==''"
    }],
    attrs: {
      "label": "套餐名称:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.PackageName))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showData.isHxOrderList),
      expression: "!showData.isHxOrderList"
    }],
    attrs: {
      "label": "套餐:"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeValue
    },
    model: {
      value: (_vm.form.PackageId),
      callback: function($$v) {
        _vm.$set(_vm.form, "PackageId", $$v)
      },
      expression: "form.PackageId"
    }
  }, [(!_vm.isKaike) ? _c('div', [_c('el-radio-button', {
    attrs: {
      "label": "1012"
    }
  }, [_vm._v("D套餐开课")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "1008"
    }
  }, [_vm._v("2017Q4会销开课")])], 1) : _c('div', [_c('el-radio-button', {
    attrs: {
      "label": "10121"
    }
  }, [_vm._v("D套餐开课")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "10083"
    }
  }, [_vm._v("2017Q4会销开课")])], 1)])], 1), _vm._v(" "), (_vm.school !== '') ? _c('el-form-item', {
    attrs: {
      "label": "支付对象:"
    }
  }, [_c('el-select', {
    staticClass: "formlength",
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.form.PayObject),
      callback: function($$v) {
        _vm.$set(_vm.form, "PayObject", $$v)
      },
      expression: "form.PayObject"
    }
  }, _vm._l((_vm.PayObject), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.label
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.PackageId !== 10082 && _vm.form.PackageId !== ''),
      expression: "form.PackageId!==10082&&form.PackageId!==''"
    }],
    attrs: {
      "label": "开课班级数:"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": _vm.minNum,
      "max": _vm.showData.lessClassNum,
      "disabled": _vm.form.OrderId !== 0
    },
    on: {
      "change": _vm.changeNum
    },
    model: {
      value: (_vm.form.ClassNum),
      callback: function($$v) {
        _vm.$set(_vm.form, "ClassNum", $$v)
      },
      expression: "form.ClassNum"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.OrderId == 0 && !_vm.isKaike),
      expression: "form.OrderId==0&&!isKaike"
    }],
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(总开班数：" + _vm._s(this.showData.ClassNum) + "；已开课数：" + _vm._s(this.showData.OpenClassNum) + "；剩余可开课数：" + _vm._s(this.showData.lessClassNum) + ")")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.OrderId == 0 && _vm.form.AgentId !== 0 && _vm.isKaike && _vm.form.SchoolId !== 0),
      expression: "form.OrderId==0&&form.AgentId!==0&&isKaike&&form.SchoolId!==0"
    }],
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(智趣坞65寸总发货：" + _vm._s(this.showData.ClassNum) + "；已开课数：" + _vm._s(this.showData.OpenClassNum) + "；剩余可开课数：" + _vm._s(this.showData.lessClassNum) + ")")])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.PackageId !== '' && !_vm.showData.isContinueClass),
      expression: "form.PackageId!==''&&!showData.isContinueClass"
    }],
    attrs: {
      "label": "配置Hi幼教资源包:"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(配套" + _vm._s(_vm.packagesNum) + "套资源包)")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-left": "0px",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.packagesD,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "资源包"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                                " + _vm._s(scope.row.value) + "\n                            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          staticStyle: {
            "margin-left": "5px"
          },
          attrs: {
            "size": "small",
            "min": 0
          },
          model: {
            value: (scope.row.ProNum),
            callback: function($$v) {
              _vm.$set(scope.row, "ProNum", $$v)
            },
            expression: "scope.row.ProNum"
          }
        })]
      }
    }])
  })], 1)], 1), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.PackageId == 10082 && _vm.debtPackage.HiDebtInfo > 0 && _vm.school !== '' || !_vm.showData.isContinueAdd),
      expression: "form.PackageId == 10082&&debtPackage.HiDebtInfo>0&&school!==''||!showData.isContinueAdd"
    }],
    attrs: {
      "label": "配置Hi幼教资源包:"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-left": "0px",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.packagesD,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "资源包"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                                " + _vm._s(scope.row.value) + "\n                            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          staticStyle: {
            "margin-left": "5px"
          },
          attrs: {
            "size": "small",
            "min": 0
          },
          model: {
            value: (scope.row.ProNum),
            callback: function($$v) {
              _vm.$set(scope.row, "ProNum", $$v)
            },
            expression: "scope.row.ProNum"
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.PackageId == 10082 && _vm.debtPackage.BookHiData > 0 && _vm.school !== '' || !_vm.showData.isContinueAdd),
      expression: "form.PackageId == 10082&&debtPackage.BookHiData>0&&school!==''||!showData.isContinueAdd"
    }],
    attrs: {
      "label": "配置智趣坞资源包:"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-left": "0px",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.packageZ,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "资源包"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                                " + _vm._s(scope.row.value) + "\n                            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          staticStyle: {
            "margin-left": "5px"
          },
          attrs: {
            "size": "small",
            "min": 0
          },
          model: {
            value: (scope.row.ProNum),
            callback: function($$v) {
              _vm.$set(scope.row, "ProNum", $$v)
            },
            expression: "scope.row.ProNum"
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "label": "资源包价格:"
    }
  }, [(!_vm.showData.isReadOnly) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.price) + "元")]) : _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.form.OrderPrice) + "元")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "label": "邮费:"
    }
  }, [(!_vm.showData.isReadOnly) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.postage) + "元")]) : _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.form.OrderPostPrice) + "元")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "需支付:"
    }
  }, [(!_vm.showData.isReadOnly) ? _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.totalPrice) + "元")]) : _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.TotalPrice) + "元")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择收货地址:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ConsigneeList))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showData.isReadOnly && _vm.ConsigneeList !== ''),
      expression: "!showData.isReadOnly&&ConsigneeList!==''"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.changeAddress
    }
  }, [_vm._v("修改地址")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收货人及联系方式:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ConsigneeListName))])]), _vm._v(" "), _c('div', [_c('el-form-item', {
    attrs: {
      "label": "寄送方式:",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v("物流")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "寄送支付方式:",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v("寄付（送货）")])])], 1)], 1), _vm._v(" "), _vm._l((_vm.payList), function(item, index) {
    return (_vm.price > 0 || _vm.totalPrice > 0) ? _c('payTypeInfo', {
      ref: 'payInfo' + (index + 1),
      refInFor: true,
      attrs: {
        "myIndex": (index + 1),
        "value": item,
        "isReadOnly": _vm.showData.isReadOnly,
        "hasDelFn": _vm.isDelShow[index]
      },
      on: {
        "delPayfn": _vm.delPayFn
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showData.isReadOnly && (this.price > 0 || _vm.totalPrice > 0)),
      expression: "!showData.isReadOnly&&(this.price>0||totalPrice>0)"
    }]
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.addFn
    }
  }, [_vm._v("新增支付方式")])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.PackageId !== 10082),
      expression: "form.PackageId!==10082"
    }],
    attrs: {
      "label": "下单备注:"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "readonly": _vm.showData.isReadOnly
    },
    model: {
      value: (_vm.form.OrderRemark),
      callback: function($$v) {
        _vm.$set(_vm.form, "OrderRemark", $$v)
      },
      expression: "form.OrderRemark"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.AddDialogVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showData.isReadOnly),
      expression: "!showData.isReadOnly"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 1)], 2)], 1), _vm._v(" "), _c('chooseDialog', {
    ref: "chooseDialog",
    on: {
      "dialogList": _vm.getDialogList
    }
  }), _vm._v(" "), _c('AddressDialog', {
    ref: "AddressDialog",
    on: {
      "address": _vm.getAddress,
      "getSchoolConsigneeList": _vm.getSchoolConsigneeList
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9eb92e48!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SchoolOrder/components/addOrderDialog/index.vue
// module id = 1545
// module chunks = 1